// extracted by mini-css-extract-plugin
export var animationContainer = "_pd-0";
export var footer = "_pd-1";
export var gray = "_pd-2";
export var lineItem = "_pd-3";
export var lineItemImage = "_pd-4";
export var lineItemInfo = "_pd-5";
export var lineItemText = "_pd-6";
export var lineItems = "_pd-7";
export var modalContent = "_pd-8";
export var options = "_pd-9";
export var orderName = "_pd-a";
export var refundAmount = "_pd-b";